/** Legacy local pen rats are disabled; use SpacetimeDB spawners with template `rat`. */
export const PEN_RAT_COUNT = 0;
export const PEN_RAT_SIZE = 0.42;
export const MAX_PEN_RAT_HEALTH = 14;
export const PEN_RAT_BITE_DAMAGE = 4;
/** Game ticks between bites when orthogonally adjacent to the player. */
export const PEN_RAT_ATTACK_TICK_INTERVAL = 3;
